import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FeatureFlagsState {
    loadChatData: boolean;
    loadNotificationsData: boolean;
    loadTasksData: boolean;
    loadCalendarData: boolean;
}

const getInitialFlags = (): FeatureFlagsState => {
    const stored = localStorage.getItem("featureFlags");
    if (stored) {
        try {
            return JSON.parse(stored);
        } catch (e) {
            console.error("Failed to parse feature flags from localStorage", e);
        }
    }

    // По умолчанию все флаги включены (true)
    return {
        loadChatData: process.env.REACT_APP_LOAD_CHAT_DATA !== "false",
        loadNotificationsData: process.env.REACT_APP_LOAD_NOTIFICATIONS_DATA !== "false",
        loadTasksData: process.env.REACT_APP_LOAD_TASKS_DATA !== "false",
        loadCalendarData: process.env.REACT_APP_LOAD_CALENDAR_DATA !== "false",
    };
};

const initialState: FeatureFlagsState = getInitialFlags();

const featureFlagsSlice = createSlice({
    name: "featureFlags",
    initialState,
    reducers: {
        setFeatureFlag(
            state,
            action: PayloadAction<{ flag: keyof FeatureFlagsState; value: boolean }>
        ) {
            state[action.payload.flag] = action.payload.value;
            // Сохраняем в localStorage для сохранения между сессиями
            localStorage.setItem("featureFlags", JSON.stringify(state));
        },
        setFeatureFlags(state, action: PayloadAction<Partial<FeatureFlagsState>>) {
            Object.assign(state, action.payload);
            localStorage.setItem("featureFlags", JSON.stringify(state));
        },
        resetFeatureFlags() {
            const defaultFlags = getInitialFlags();
            localStorage.setItem("featureFlags", JSON.stringify(defaultFlags));
            return defaultFlags;
        },
    },
});

export const { setFeatureFlag, setFeatureFlags, resetFeatureFlags } = featureFlagsSlice.actions;

export default featureFlagsSlice.reducer;
